import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const getPublicHolidays = async ({ companyCode }) => {
  const {data} = await http_payroll.get(
    `${Api_EndPoints.PublicHolidays}?companyCode=${companyCode}`
  );
  return data;
};

const addPublicHoliday = async (input) => {
  const data = await http_payroll.post(
    Api_EndPoints.InsertPublicHoliday,
    input
  );
  return data;
};

const updatePublicHoliday = async (input) => {
  const data = await http_payroll.put(
    Api_EndPoints.UpdatePublicHoliday,
    input
  );
  return data;
};

export const useGetPublicHolidaysQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.PublicHolidays],
    queryFn: () => getPublicHolidays(companyCode),
    refetchOnWindowFocus: false,
  });
};

export const useCreatePublicHolidayMutation = () => {
  return useMutation({
    mutationFn: addPublicHoliday,
  });
};

export const useUpdatePublicHolidayMutation = () => {
  return useMutation({
    mutationFn: updatePublicHoliday,
  });
};
